module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about-us"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (_vm.props) ? _c('div', [_c('Hero', {
    attrs: {
      "props": _vm.props.acf.hero
    }
  }), _c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.header
    }
  }), _c('div', {
    staticClass: "page-about-us__parallax-1"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.7),
      expression: "0.7"
    }],
    staticClass: "page-about-us__parallax-mask1",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.parallax1.background_image + ')'
    })
  }), _c('HeadBar', {
    attrs: {
      "props": _vm.props.acf.parallax1
    }
  })], 1), _c('div', {
    staticClass: "page-about-us__meet-doctors"
  }, [_c('div', {
    staticClass: "page-about-us__meet-doctors-container"
  }, [_c('div', {
    staticClass: "page-about-us__divider"
  }), _c('div', {
    staticClass: "page-about-us__meet-doctors-2"
  }, [_c('div', {
    staticClass: "page-about-us__meet-doctors-2-left"
  }, [_c('TextBox', {
    staticClass: "page-about-us__right1",
    attrs: {
      "props": _vm.props.acf.meetdoc.baum
    }
  }), _c('TextBox', {
    staticClass: "page-about-us__right2",
    attrs: {
      "props": _vm.props.acf.meetdoc.baumcontent
    }
  })], 1), _c('div', {
    staticClass: "page-about-us__meet-doctors-2-right"
  }, [_c('div', {
    staticClass: "page-about-us__meet-doctors-image",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.meetdoc.background_image2 + ')'
    })
  })])]), _c('div', {
    staticClass: "page-about-us__divider"
  }), _c('div', {
    staticClass: "page-about-us__meet-doctors-1"
  }, [_c('div', {
    staticClass: "page-about-us__meet-doctors-1-left"
  }, [_c('div', {
    staticClass: "page-about-us__meet-doctors-image",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.meetdoc.wolfimage + ')'
    })
  })]), _c('div', {
    staticClass: "page-about-us__meet-doctors-1-right"
  }, [_c('TextBox', {
    staticClass: "page-about-us__right1",
    attrs: {
      "props": _vm.props.acf.meetdoc.wolf
    }
  }), _c('TextBox', {
    staticClass: "page-about-us__right2",
    attrs: {
      "props": _vm.props.acf.meetdoc.wolfcontent
    }
  })], 1)])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-660a9d5d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/about-us/about-us.pug
// module id = 591
// module chunks = 1